module.exports = __webpack_public_path__ + "static/img/elegantMannersBig4.51a7807d.png";